export default {
  title_single: 'Esta actividad ya existe. ¿Qué desea hacer?',
  title_multiple: 'Estas actividades ya existen. ¿Qué desea hacer?',
  subtitle_multiple: 'todas las otras actividades ya fueron creadas',
  create: 'Crear de todos modos',
  edit: 'Editar lo que ya existe'
}
